import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';
import OrderList from './components/OrderList';
import RentCar from './RentCar';

const CURRENCY_SYMBOLS = {
    CNY: '¥', MYR: 'RM', THB: '฿', VND: '₫', PHP: '₱', LKR: 'Rs', AED: 'د.إ',
    DEFAULT: '¥'
};

function App() {
    const [tg, setTg] = useState(null);
    const [user, setUser] = useState(null);
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [merchants, setMerchants] = useState([]);
    const [selectedMerchant, setSelectedMerchant] = useState(null);
    const [products, setProducts] = useState([]);
    const [cart, setCart] = useState({});
    const [view, setView] = useState('cities');
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [selectedPayment, setSelectedPayment] = useState('');
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [searchType, setSearchType] = useState('merchant');
    const [productSearchKeyword, setProductSearchKeyword] = useState('');
    const [customCategories, setCustomCategories] = useState([]);
    const [selectedCustomCategory, setSelectedCustomCategory] = useState(null);
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [addressNote, setAddressNote] = useState('');
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [orders, setOrders] = useState([]);
    const [merchantRatings, setMerchantRatings] = useState({});
    const [productRatings, setProductRatings] = useState({});
    const [searchProducts, setSearchProducts] = useState([]);
    const [featuredProducts, setFeaturedProducts] = useState([]);
    const [coupons, setCoupons] = useState([]);
    const [userCoupons, setUserCoupons] = useState([]);
    const [selectedCoupon, setSelectedCoupon] = useState(null);
    const [couponDiscount, setCouponDiscount] = useState(0);
    const [merchantCurrency, setMerchantCurrency] = useState('CNY');

    const safeShowPopup = (options, callback) => {
        if (tg && typeof tg.showPopup === 'function') {
            tg.showPopup(options, callback);
        } else {
            const message = typeof options === 'string' ? options : options.message || '提示';
            alert(message);
            if (callback) callback('ok');
        }
    };

    useEffect(() => {
        const tg = window.Telegram.WebApp;
        tg.ready();
        tg.expand();
        // 检测是否从租车按钮进入
const urlParams = new URLSearchParams(window.location.search);
const startParam = urlParams.get('start');
if (startParam === 'rentcar') {
    setView('rentcar');
}
        setTg(tg);
        if (tg.initDataUnsafe?.user) {
            setUser(tg.initDataUnsafe.user);
        }
        fetchCities();
        fetchCategories();
    }, []);

    const fetchCities = async () => {
        try {
            const res = await axios.get('/api/cities');
            setCities(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const fetchCategories = async () => {
        try {
            const res = await axios.get('/api/categories');
            setCategories(res.data);
        } catch (err) {
            console.error(err);
        }
    };

const fetchMerchantsByCity = async (cityId, categoryId = null, keyword = '', type = 'merchant') => {
    //alert(`搜索: ${keyword}, 类型: ${type}, 城市: ${cityId}`);
    try {
        let url;
        if (keyword.trim() && type === 'product') {
            // 产品搜索
            const encodedKeyword = encodeURIComponent(keyword);
            const res = await axios.get(`/api/cities/${cityId}/search-products?q=${encodedKeyword}`);
            
            // 调试：查看响应结构
            //alert(`res.data 类型: ${typeof res.data}, 是数组: ${Array.isArray(res.data)}`);
            //alert(`res.data 内容预览: ${JSON.stringify(res.data).substring(0, 200)}`);
            
            // 健壮提取数组
            let products = [];
            if (Array.isArray(res.data)) {
                products = res.data;
            } else if (res.data && Array.isArray(res.data.data)) {
                products = res.data.data;
            } else if (res.data && Array.isArray(res.data.products)) {
                products = res.data.products;
            }
            
            //alert(`提取产品数: ${products.length}`);
            setSearchProducts(products);
            setView('searchProducts');
            return;
        } else if (keyword.trim() && type === 'merchant') {
            // 商家搜索
            url = `/api/cities/${cityId}/search?q=${encodeURIComponent(keyword)}&type=merchant`;
            const res = await axios.get(url);
            
            //alert(`商家搜索响应类型: ${typeof res.data}, 是数组: ${Array.isArray(res.data)}`);
            //alert(`商家搜索内容预览: ${JSON.stringify(res.data).substring(0, 200)}`);
            
            let merchantsData = [];
            if (Array.isArray(res.data)) {
                merchantsData = res.data;
            } else if (res.data && Array.isArray(res.data.data)) {
                merchantsData = res.data.data;
            }
            
            //alert(`提取商家数: ${merchantsData.length}`);
            merchantsData.sort((a, b) => (b.orderCount || 0) - (a.orderCount || 0));
            setMerchants(merchantsData);
            merchantsData.forEach(merchant => fetchMerchantRating(merchant.id));
            setView('merchants');
        } else {
            // 无关键词，加载全部商家
            url = `/api/cities/${cityId}/merchants`;
            if (categoryId) url += `?category=${categoryId}`;
            const res = await axios.get(url);
            
            let merchantsData = [];
            if (Array.isArray(res.data)) {
                merchantsData = res.data;
            } else if (res.data && Array.isArray(res.data.data)) {
                merchantsData = res.data.data;
            }
            
            merchantsData.sort((a, b) => (b.orderCount || 0) - (a.orderCount || 0));
            setMerchants(merchantsData);
            merchantsData.forEach(merchant => fetchMerchantRating(merchant.id));
            setView('merchants');
        }
    } catch (err) {
        console.error('搜索失败:', err);
        alert(`请求失败: ${err.message}`);
    }
};

    const fetchFeaturedProducts = async (merchantId) => {
        try {
            const res = await axios.get(`/api/merchants/${merchantId}/featured-products`);
            setFeaturedProducts(res.data.data || []);
        } catch (err) {
            console.error('获取置顶商品失败', err);
            setFeaturedProducts([]);
        }
    };

    const fetchUserCoupons = async (merchantId) => {
        if (!user) return;
        try {
            const res = await axios.get(`/api/user/coupons?userId=${user.id}`);
            const merchantCoupons = await axios.get(`/api/merchants/${merchantId}/coupons/available`);
            const merchantCouponIds = merchantCoupons.data.data.map(c => c.id);
            const availableCoupons = res.data.data.filter(coupon => 
                merchantCouponIds.includes(coupon.coupon_id)
            );
            setUserCoupons(availableCoupons);
        } catch (err) {
            console.error('获取用户优惠券失败:', err);
            setUserCoupons([]);
        }
    };

    const fetchProducts = async (merchantId, merchant) => {
        // 添加下面两行
    const currency = merchant.currency_code || 'CNY';
    setMerchantCurrency(currency);
        try {
            const [productsRes, methodsRes, customCategoriesRes, couponsRes] = await Promise.all([
                axios.get(`/api/merchants/${merchantId}/products`),
                axios.get(`/api/merchants/${merchantId}/payment-methods`),
                axios.get(`/api/merchants/${merchantId}/custom-categories`),
                axios.get(`/api/merchants/${merchantId}/coupons`).catch(() => ({ data: { data: [] } }))
            ]);
            
            setProducts(productsRes.data);
            productsRes.data.forEach(product => fetchProductRating(product.id));
            setPaymentMethods(methodsRes.data.methods || ['现金']);
            setSelectedPayment(methodsRes.data.methods[0] || '现金');
            setCustomCategories(customCategoriesRes.data);
            setCoupons(couponsRes.data.data || []);
            setSelectedCustomCategory(null);
            setSelectedMerchant(merchant);
            await fetchFeaturedProducts(merchantId);
            await fetchUserCoupons(merchantId);
            setSelectedCoupon(null);
            setCouponDiscount(0);
            setView('products');
        } catch (err) {
            console.error(err);
        }
    };

    const fetchProductsWithCategory = async (categoryId) => {
        if (!selectedMerchant) return;
        try {
            let url = `/api/merchants/${selectedMerchant.id}/products`;
            if (categoryId) url += `?categoryId=${categoryId}`;
            const res = await axios.get(url);
            setProducts(res.data);
            if (res.data && res.data.length > 0) {
                res.data.forEach(product => fetchProductRating(product.id));
            }
        } catch (err) {
            console.error(err);
        }
    };

    const fetchMerchantRating = async (merchantId) => {
        try {
            const res = await axios.get(`/api/merchants/${merchantId}/reviews?limit=1`);
            const avg = parseFloat(res.data.average_rating) || 0;
            setMerchantRatings(prev => ({ ...prev, [merchantId]: avg }));
        } catch (err) {
            console.error('获取商家评分失败', err);
        }
    };

    const fetchProductRating = async (productId) => {
        try {
            const res = await axios.get(`/api/products/${productId}/reviews?limit=1`);
            const avg = parseFloat(res.data.average_rating) || 0;
            setProductRatings(prev => ({ ...prev, [productId]: avg }));
        } catch (err) {
            console.error('获取商品评分失败', err);
        }
    };

const addToCart = (product) => {
    const merchantId = selectedMerchant.id;
    const newCart = { ...cart };
    if (!newCart[merchantId]) {
        newCart[merchantId] = {
            merchant: selectedMerchant,
            items: []
        };
    }
    const existing = newCart[merchantId].items.find(item => item.product.id === product.id);
    if (existing) {
        existing.quantity += 1;
    } else {
        newCart[merchantId].items.push({ product, quantity: 1 });
    }
    setCart(newCart);
};

    const updateQuantity = (merchantId, productId, delta) => {
        const newCart = { ...cart };
        const merchantCart = newCart[merchantId];
        if (!merchantCart) return;
        const index = merchantCart.items.findIndex(item => item.product.id === productId);
        if (index >= 0) {
            merchantCart.items[index].quantity += delta;
            if (merchantCart.items[index].quantity <= 0) {
                merchantCart.items.splice(index, 1);
            }
        }
        if (merchantCart.items.length === 0) {
            delete newCart[merchantId];
        }
        setCart(newCart);
    };

    const getTotalAmount = (merchantId) => {
        if (!cart[merchantId]) return 0;
        return cart[merchantId].items.reduce((sum, item) => sum + item.product.price * item.quantity, 0);
    };

    const getGrandTotal = () => {
        return Object.keys(cart).reduce((total, mid) => total + getTotalAmount(parseInt(mid)), 0);
    };

    const selectCoupon = (coupon) => {
        const subtotal = getTotalAmount(selectedMerchant.id);
        if (subtotal >= coupon.min_amount) {
            setSelectedCoupon(coupon);
            setCouponDiscount(parseFloat(coupon.reduction_amount));
        } else {
            safeShowPopup({
                title: '提示',
                message: `满${coupon.min_amount}元可用，当前订单金额${subtotal}元`,
                buttons: [{ type: 'ok' }]
            });
        }
    };

    const cancelCoupon = () => {
        setSelectedCoupon(null);
        setCouponDiscount(0);
    };

    const placeOrder = async (merchantId, finalAmount, usedCoupon = null) => {
        if (!user) {
            safeShowPopup({ title: '错误', message: '无法获取用户信息' });
            return;
        }
        const merchantCart = cart[merchantId];
        const totalAmount = finalAmount !== undefined ? finalAmount : getTotalAmount(merchantId);
        try {
            const res = await axios.post('/api/orders', {
                userId: user.id,
                merchantId,
                items: merchantCart.items.map(item => ({
                    productId: item.product.id,
                    productName: item.product.name,
                    price: item.product.price,
                    quantity: item.quantity
                })),
                totalAmount: totalAmount,
                paymentMethod: selectedPayment,
                deliveryAddress: deliveryAddress,
                addressText: addressNote,
                addressNote: addressNote,
                note: '',
                couponId: usedCoupon ? usedCoupon.id : null
            }, {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            const newCart = { ...cart };
            delete newCart[merchantId];
            setCart(newCart);
            setSelectedCoupon(null);
            setCouponDiscount(0);
            safeShowPopup({
                title: '下单成功',
                message: `订单号: ${res.data.orderNumber}`,
                buttons: [{ type: 'ok' }]
            });
            setView('merchants');
        } catch (err) {
            console.error(err);
            safeShowPopup({ title: '下单失败', message: err.response?.data?.error || '请稍后重试' });
        }
    };

    const fetchOrders = async () => {
        if (!user) return;
        try {
            const res = await axios.get(`/api/orders/my?userId=${user.id}`, {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            setOrders(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const submitReview = async (orderId, overall_rating, comment, productReviews) => {
        try {
            await axios.post(`/api/orders/${orderId}/review`, {
                userId: user.id,
                overall_rating,
                comment,
                product_reviews: productReviews
            }, {
                headers: { 'x-telegram-init-data': tg.initData }
            });
            safeShowPopup({ title: '评价成功', message: '感谢您的反馈！' });
            fetchOrders();
        } catch (err) {
            console.error(err);
            safeShowPopup({ title: '评价失败', message: err.response?.data?.error || '请稍后重试' });
        }
    };

    const openReviewModal = (order) => {
        if (!user) {
            safeShowPopup({ title: '错误', message: '无法获取用户信息' });
            return;
        }
        const rating = window.prompt('请为本次订单评分（1-5星）：', '5');
        if (rating === null) return;
        const comment = window.prompt('请输入您的评价：', '');
        if (comment === null) return;
        submitReview(order.id, parseInt(rating), comment, []);
    };

    const openProductDetail = (product) => {
        setSelectedProduct(product);
        setCurrentImageIndex(0);
        setView('productDetail');
    };

    const closeProductDetail = () => {
        setSelectedProduct(null);
        setView('products');
    };

    const claimCoupon = async (couponId) => {
        if (!user) {
            safeShowPopup({ title: '提示', message: '请先登录' });
            return;
        }
        try {
            const res = await axios.post('/api/coupons/claim', {
                userId: user.id,
                couponId: couponId
            });
            safeShowPopup({ title: '成功', message: res.data.message });
            if (selectedMerchant) {
                const couponsRes = await axios.get(`/api/merchants/${selectedMerchant.id}/coupons`).catch(() => ({ data: { data: [] } }));
                setCoupons(couponsRes.data.data || []);
                await fetchUserCoupons(selectedMerchant.id);
            }
        } catch (err) {
            safeShowPopup({ title: '失败', message: err.response?.data?.message || '领取失败' });
        }
    };

    const renderProductDetail = () => {
        if (!selectedProduct) return null;
        const images = selectedProduct.images && selectedProduct.images.length ? selectedProduct.images : [];
        const hasImages = images.length > 0;
        const nextImage = () => {
            if (hasImages) setCurrentImageIndex((prev) => (prev + 1) % images.length);
        };
        const prevImage = () => {
            if (hasImages) setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
        };
        return (
            <div className="product-detail-page">
                <button className="back-btn" onClick={closeProductDetail}>← 返回商品列表</button>
                <div className="detail-container">
                    {hasImages && (
                        <div className="detail-images">
                            <div className="main-image">
                                <img src={images[currentImageIndex]} alt={selectedProduct.name} />
                                {images.length > 1 && (
                                    <>
                                        <button className="image-nav prev" onClick={prevImage}>‹</button>
                                        <button className="image-nav next" onClick={nextImage}>›</button>
                                    </>
                                )}
                            </div>
                            {images.length > 1 && (
                                <div className="thumbnail-list">
                                    {images.map((url, idx) => (
                                        <img
                                            key={idx}
                                            src={url}
                                            alt={`缩略图 ${idx+1}`}
                                            className={idx === currentImageIndex ? 'active' : ''}
                                            onClick={() => setCurrentImageIndex(idx)}
                                        />
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                    <div className="detail-info">
                        <h2>{selectedProduct.name}</h2>
                        <p className="detail-description">{selectedProduct.description || '暂无描述'}</p>
                        <p className="detail-price">{CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{selectedProduct.price}</p>
                        <div className="detail-actions">
                            {selectedProduct.is_sold_out === 1 ? (
                                <button className="add-to-cart-btn" disabled>已售罄</button>
                            ) : (
                                <button className="add-to-cart-btn" onClick={() => addToCart(selectedProduct)}>加入购物车</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderCities = () => {
        const grouped = cities.reduce((acc, city) => {
            if (!acc[city.country]) acc[city.country] = [];
            acc[city.country].push(city);
            return acc;
        }, {});
        return (
            <div className="city-selector">
                {Object.entries(grouped).map(([country, cityList]) => (
                    <div key={country}>
                        <h3 className="country-title">{country}</h3>
                        <div className="city-list">
                            {cityList.map(city => (
                                <div key={city.id} className="city-card" onClick={() => { setSelectedCity(city); fetchMerchantsByCity(city.id); }}>
                                    <span className="city-name">{city.city_name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

const renderMerchants = () => (
    <div>
        <button className="back-btn" onClick={() => setView('cities')}>← 返回城市</button>
        <h2 style={{ 
            textAlign: 'center', 
            fontSize: '16px', 
            fontWeight: '500',
            margin: '8px 0',
            color: '#333'
        }}>
            {selectedCity?.country} · {selectedCity?.city_name}
        </h2>
        <div className="search-bar">
            <input
                type="text"
                placeholder="搜索商家或产品..."
                value={searchKeyword}
                onChange={e => setSearchKeyword(e.target.value)}
                onKeyPress={e => {
                    if (e.key === 'Enter') {
                        fetchMerchantsByCity(selectedCity.id, selectedCategory, searchKeyword, searchType);
                    }
                }}
            />
            <div className="search-type">
                <label>
                    <input
                        type="radio"
                        value="merchant"
                        checked={searchType === 'merchant'}
                        onChange={() => setSearchType('merchant')}
                    />
                    商家名称
                </label>
                <label>
                    <input
                        type="radio"
                        value="product"
                        checked={searchType === 'product'}
                        onChange={() => setSearchType('product')}
                    />
                    产品名称
                </label>
            </div>
            <button onClick={() => fetchMerchantsByCity(selectedCity.id, selectedCategory, searchKeyword, searchType)}>搜索</button>
            {searchKeyword && (
                <button onClick={() => {
                    setSearchKeyword('');
                    fetchMerchantsByCity(selectedCity.id, selectedCategory);
                }}>清除</button>
            )}
        </div>
        {/* 调试信息 */}
        {searchKeyword && (
            <div style={{ padding: '8px', background: '#f0f0f0', marginBottom: '10px', fontSize: '12px', color: '#333' }}>
                搜索词: "{searchKeyword}" | 类型: {searchType === 'product' ? '产品' : '商家'}
            </div>
        )}
        <div className="categories-bar">
            <button
                className={selectedCategory === null ? 'category-btn active' : 'category-btn'}
                onClick={() => {
                    setSelectedCategory(null);
                    fetchMerchantsByCity(selectedCity.id, null, searchKeyword, searchType);
                }}
            >
                全部
            </button>
            {categories.map(cat => (
                <button
                    key={cat.id}
                    className={selectedCategory === cat.id ? 'category-btn active' : 'category-btn'}
                    onClick={() => {
                        setSelectedCategory(cat.id);
                        fetchMerchantsByCity(selectedCity.id, cat.id, searchKeyword, searchType);
                    }}
                >
                    {cat.name}
                </button>
            ))}
        </div>
        <div className="merchants-list">
            {merchants.map(m => (
                <div key={m.id} className="merchant-card" onClick={() => m.is_closed !== 1 && fetchProducts(m.id, m)}>
                    <img src={m.logo || 'https://via.placeholder.com/80'} alt={m.name} />
                    <div className="merchant-info">
                        <h3>{m.name}</h3>
                        <p>{m.description}</p>
                        {m.is_closed === 1 && <span className="closed-tag">已闭店</span>}
                        <div className="merchant-rating">
                            ⭐ {merchantRatings[m.id] ? merchantRatings[m.id].toFixed(1) : '暂无评分'}
                        </div>
                        <div className="merchant-orders">
                            📦 总订单数: {m.orderCount !== undefined ? m.orderCount : 0}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

const renderProducts = () => {
    console.log('products数量:', products.length);
    const filteredProducts = products.filter(p =>
        p.name.toLowerCase().includes(productSearchKeyword.toLowerCase())
    );

    const featuredProductIds = featuredProducts.map(p => p.id);

    return (
        <div style={{ paddingBottom: '80px' }}>
            <button className="back-btn" onClick={() => setView('merchants')}>← 返回商家</button>

            <div className="merchant-header">
                <div className="merchant-header-content">
                    <div className="merchant-logo">
                        <img src={selectedMerchant?.logo || 'https://via.placeholder.com/80'} alt={selectedMerchant?.name} />
                    </div>
                    <div className="merchant-info-header">
                        <h1 className="merchant-name">{selectedMerchant?.name}</h1>
                        <div className="merchant-stats">
                            <span>⭐ {merchantRatings[selectedMerchant?.id] ? merchantRatings[selectedMerchant?.id].toFixed(1) : '暂无评分'}</span>
                            <span>·</span>
                            <span>月售 {selectedMerchant?.orderCount || 0}</span>
                        </div>
                        <div className="merchant-notice">
                            {selectedMerchant?.description || ''}
                        </div>
                    </div>
                </div>
            </div>

            <div className="product-search-bar-top">
                <input
                    type="text"
                    placeholder="搜索店内产品..."
                    value={productSearchKeyword}
                    onChange={e => setProductSearchKeyword(e.target.value)}
                />
            </div>

            {coupons.length > 0 && (
                <div className="coupon-section" style={{ padding: '12px 16px', background: '#fff8f0', borderBottom: '1px solid #f0f0f0' }}>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: '#ff6b6b', marginBottom: '10px' }}>📢 领券中心</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px' }}>
                        {coupons.map(coupon => (
                            <div key={coupon.id} style={{ background: 'white', borderRadius: '8px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: '1', minWidth: '140px', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>
                                <div>
                                    <div style={{ fontWeight: 'bold', color: '#ff6b6b', fontSize: '10px' }}>满{coupon.min_amount}减{coupon.reduction_amount}</div>
                                    <div style={{ fontSize: "9px", color: '#999' }}>{coupon.name}</div>
                                </div>
                                <button
                                    onClick={() => claimCoupon(coupon.id)}
                                    style={{ background: '#ff6b6b', color: 'white', border: 'none', borderRadius: '16px', padding: '4px 12px', fontSize: '10px', cursor: 'pointer' }}
                                >
                                    领取
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="merchant-tabs">
                <span className="tab active">点餐</span>
            </div>

            {featuredProducts.length > 0 && (
                <div className="featured-products-section">
                    <div className="featured-title">⭐ 商家推荐</div>
                    <div className="featured-products-grid">
                        {featuredProducts.map(p => (
                            <div key={p.id} className="featured-product-card" onClick={() => !p.is_sold_out && openProductDetail(p)}>
                                <div className="featured-product-image">
                                    <img src={(p.images && p.images[0]) || 'https://via.placeholder.com/100'} alt={p.name} />
                                </div>
                                <div className="featured-product-info">
                                    <h4>{p.name}</h4>
                                    <p className="featured-price">{CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{p.price}</p>
                                    {/* 置顶卡片：数量选择器替代原“加购”按钮 */}
                                    {!p.is_sold_out && (() => {
                                        const quantity = cart[selectedMerchant?.id]?.items.find(i => i.product.id === p.id)?.quantity || 0;
                                        if (quantity === 0) {
                                            return (
                                                <button
                                                    onClick={(e) => { e.stopPropagation(); addToCart(p); }}
                                                    style={{
                                                        width: '28px',
                                                        height: '28px',
                                                        borderRadius: '50%',
                                                        background: '#ff6b6b',
                                                        color: 'white',
                                                        border: 'none',
                                                        fontSize: '18px',
                                                        fontWeight: 'bold',
                                                        cursor: 'pointer',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    +
                                                </button>
                                            );
                                        } else {
                                            return (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); updateQuantity(selectedMerchant.id, p.id, -1); }}
                                                        style={{
                                                            width: '28px',
                                                            height: '28px',
                                                            borderRadius: '50%',
                                                            background: '#f0f0f0',
                                                            color: '#ff6b6b',
                                                            border: '1px solid #ff6b6b',
                                                            fontSize: '16px',
                                                            fontWeight: 'bold',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        −
                                                    </button>
                                                    <span style={{ fontSize: '14px', fontWeight: '500', minWidth: '20px', textAlign: 'center' }}>{quantity}</span>
                                                    <button
                                                        onClick={(e) => { e.stopPropagation(); addToCart(p); }}
                                                        style={{
                                                            width: '28px',
                                                            height: '28px',
                                                            borderRadius: '50%',
                                                            background: '#ff6b6b',
                                                            color: 'white',
                                                            border: 'none',
                                                            fontSize: '18px',
                                                            fontWeight: 'bold',
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            );
                                        }
                                    })()}
                                    {p.is_sold_out && (
                                        <span style={{ fontSize: '12px', color: '#999', background: '#f5f5f5', padding: '4px 10px', borderRadius: '16px' }}>售罄</span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="products-layout">
                <div className="categories-sidebar">
                    <div className="all-categories">
                        <div
                            className={`category-item ${selectedCustomCategory === null ? 'active' : ''}`}
                            onClick={() => {
                                setSelectedCustomCategory(null);
                                fetchProductsWithCategory(null);
                            }}
                        >
                            <span className="category-name">全部</span>
                        </div>
                        {customCategories.map(cat => {
                            return (
                                <div
                                    key={cat.id}
                                    className={`category-item ${selectedCustomCategory === cat.id ? 'active' : ''}`}
                                    onClick={() => {
                                        setSelectedCustomCategory(cat.id);
                                        fetchProductsWithCategory(cat.id);
                                    }}
                                >
                                    <span className="category-name">{cat.name}</span>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="products-right">
                    <div className="products-grid">
                        {filteredProducts.map(p => {
                            // 获取当前商品在购物车中的数量
                            const quantity = cart[selectedMerchant?.id]?.items.find(i => i.product.id === p.id)?.quantity || 0;

                            return (
                                <div key={p.id} style={{
                                    background: '#fff',
                                    borderRadius: '12px',
                                    padding: '12px',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                                    border: '1px solid #f0f0f0',
                                    display: 'flex',
                                    gap: '12px',
                                    cursor: !p.is_sold_out ? 'pointer' : 'default',
                                    position: 'relative'
                                }} onClick={() => !p.is_sold_out && openProductDetail(p)}>
                                    {p.is_sold_out === 1 && (
                                        <span style={{
                                            position: 'absolute',
                                            top: '8px',
                                            right: '8px',
                                            background: 'rgba(0,0,0,0.6)',
                                            color: 'white',
                                            padding: '2px 8px',
                                            borderRadius: '12px',
                                            fontSize: '10px'
                                        }}>售罄</span>
                                    )}
                                    <div style={{
                                        width: '70px',
                                        height: '70px',
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                        background: '#f5f5f5',
                                        flexShrink: 0
                                    }}>
                                        {(p.images && p.images[0]) ? (
                                            <img src={p.images[0]} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                        ) : (
                                            <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '28px', color: '#ccc' }}>🍽️</div>
                                        )}
                                    </div>
                                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                        <div>
                                            <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '4px' }}>{p.name}</div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '12px', color: '#999', marginBottom: '6px' }}>
                                                <span>⭐ {productRatings[p.id] ? productRatings[p.id].toFixed(1) : '暂无'}</span>
                                                <span>📦 {p.totalSold || 0}单</span>
                                            </div>
                                            {p.description && (
                                                <div style={{ fontSize: '12px', color: '#999', marginBottom: '6px', lineHeight: '1.3' }}>{p.description}</div>
                                            )}
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
<span style={{ fontSize: '16px', fontWeight: 'bold', color: '#ff6b6b' }}>
    {CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{p.price}
</span>
                                            {/* 普通商品卡片：数量选择器替代原“加入购物车”按钮 */}
                                            {p.is_sold_out !== 1 ? (
                                                (() => {
                                                    if (quantity === 0) {
                                                        return (
                                                            <button
                                                                onClick={(e) => { e.stopPropagation(); addToCart(p); }}
                                                                style={{
                                                                    width: '28px',
                                                                    height: '28px',
                                                                    borderRadius: '50%',
                                                                    background: '#ff6b6b',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    fontSize: '18px',
                                                                    fontWeight: 'bold',
                                                                    cursor: 'pointer',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                }}
                                                            >
                                                                +
                                                            </button>
                                                        );
                                                    } else {
                                                        return (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <button
                                                                    onClick={(e) => { e.stopPropagation(); updateQuantity(selectedMerchant.id, p.id, -1); }}
                                                                    style={{
                                                                        width: '28px',
                                                                        height: '28px',
                                                                        borderRadius: '50%',
                                                                        background: '#f0f0f0',
                                                                        color: '#ff6b6b',
                                                                        border: '1px solid #ff6b6b',
                                                                        fontSize: '16px',
                                                                        fontWeight: 'bold',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    −
                                                                </button>
                                                                <span style={{ fontSize: '14px', fontWeight: '500', minWidth: '20px', textAlign: 'center' }}>{quantity}</span>
                                                                <button
                                                                    onClick={(e) => { e.stopPropagation(); addToCart(p); }}
                                                                    style={{
                                                                        width: '28px',
                                                                        height: '28px',
                                                                        borderRadius: '50%',
                                                                        background: '#ff6b6b',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        fontSize: '18px',
                                                                        fontWeight: 'bold',
                                                                        cursor: 'pointer',
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center'
                                                                    }}
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                        );
                                                    }
                                                })()
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>

            {Object.keys(cart).length > 0 && (
                <div style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'white',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.08)',
                    padding: '10px 16px',
                    zIndex: 1000,
                    borderTop: '1px solid #f0f0f0'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        maxWidth: '500px',
                        margin: '0 auto'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                background: '#ff6b6b',
                                width: '44px',
                                height: '44px',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontSize: '20px',
                                boxShadow: '0 2px 8px rgba(255,107,107,0.3)'
                            }}>
                                🛒
                            </div>
                            <div>
                                <div style={{ fontWeight: 'bold', fontSize: '18px', color: '#333' }}>
                                    {getGrandTotal()} 元
                                </div>
                                <div style={{ fontSize: '12px', color: '#999' }}>
                                    共 {Object.values(cart).reduce((sum, mc) => sum + mc.items.reduce((s, i) => s + i.quantity, 0), 0)} 件商品
                                </div>
                            </div>
                        </div>
                        <button
                            onClick={() => setView('cart')}
                            style={{
                                background: '#ff6b6b',
                                color: 'white',
                                border: 'none',
                                padding: '10px 24px',
                                borderRadius: '30px',
                                fontSize: '15px',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                boxShadow: '0 2px 8px rgba(255,107,107,0.3)',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'scale(1.02)';
                                e.target.style.boxShadow = '0 4px 12px rgba(255,107,107,0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'scale(1)';
                                e.target.style.boxShadow = '0 2px 8px rgba(255,107,107,0.3)';
                            }}
                        >
                            去结算
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

 const renderSearchProducts = () => {
     //alert(`渲染产品搜索结果，数量: ${searchProducts.length}`);
    if (searchProducts.length === 0) {
        return (
            <div>
                <button className="back-btn" onClick={() => setView('merchants')}>← 返回商家列表</button>
                <p>未找到相关产品</p>
            </div>
        );
    }

    return (
        <div>
            <button className="back-btn" onClick={() => setView('merchants')}>← 返回商家列表</button>
            <h2 style={{ fontSize: '18px', margin: '16px 0' }}>产品搜索结果</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                {searchProducts.map(p => (
                    <div key={p.id} style={{
                        background: '#fff',
                        borderRadius: '12px',
                        padding: '12px',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
                        border: '1px solid #f0f0f0',
                        display: 'flex',
                        gap: '12px',
                        cursor: !p.is_sold_out ? 'pointer' : 'default'
                    }} onClick={() => !p.is_sold_out && openProductDetail(p)}>
                        <div style={{
                            width: '70px',
                            height: '70px',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            background: '#f5f5f5',
                            flexShrink: 0
                        }}>
                            {(p.images && p.images[0]) ? (
                                <img src={p.images[0]} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            ) : (
                                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '28px', color: '#ccc' }}>🍽️</div>
                            )}
                        </div>
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                            <div>
                                <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '4px' }}>{p.name}</div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', fontSize: '12px', color: '#999', marginBottom: '6px' }}>
                                    <span>🏪 {p.merchant_name}</span>
                                    <span>⭐ {p.avg_rating ? p.avg_rating.toFixed(1) : '暂无'}</span>
                                    <span>📦 {p.total_sold || 0}单</span>
                                </div>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#ff6b6b' }}>
    {CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{p.price}
</span>
                                {p.is_sold_out === 1 ? (
                                    <span style={{ fontSize: '12px', color: '#999', background: '#f5f5f5', padding: '4px 10px', borderRadius: '16px' }}>售罄</span>
                                ) : (
                                    <button
                                        onClick={(e) => { e.stopPropagation(); addToCart(p); }}
                                        style={{
                                            background: 'transparent',
                                            color: '#ff6b6b',
                                            border: '1px solid #ff6b6b',
                                            padding: '4px 14px',
                                            borderRadius: '20px',
                                            fontSize: '12px',
                                            fontWeight: '500',
                                            cursor: 'pointer'
                                        }}
                                        onMouseEnter={(e) => { e.target.style.background = '#ff6b6b'; e.target.style.color = 'white'; }}
                                        onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#ff6b6b'; }}
                                    >
                                        加入购物车
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            {Object.keys(cart).length > 0 && (
                <div className="cart-summary" onClick={() => setView('cart')}>
                    🛒 查看购物车 (共 {getGrandTotal()} 元)
                </div>
            )}
        </div>
    );
};

    const renderCart = () => {
        if (Object.keys(cart).length === 0) {
            return (
                <div>
                    <button className="back-btn" onClick={() => setView('products')}>← 继续购物</button>
                    <p>购物车是空的</p>
                </div>
            );
        }
        
        const merchantIds = Object.keys(cart);
        const currentMerchantId = parseInt(merchantIds[0]);
        const mc = cart[currentMerchantId];
        const subtotal = getTotalAmount(currentMerchantId);
        const discount = couponDiscount;
        const finalAmount = subtotal - discount;
       
        
        return (
            <div>
                <button className="back-btn" onClick={() => setView('products')}>← 继续购物</button>
                <h2>购物车</h2>
                {merchantIds.map(merchantId => {
                    const mcItem = cart[merchantId];
                    const itemSubtotal = getTotalAmount(parseInt(merchantId));
                    const itemDiscount = parseInt(merchantId) === currentMerchantId ? discount : 0;
                    const itemFinalAmount = itemSubtotal - itemDiscount;
                    const merchantCurrency = mcItem?.merchant?.currency_code || 'CNY';
                    
                    return (
                        <div key={merchantId} className="cart-merchant" style={{ marginBottom: '20px', border: '1px solid #eee', padding: '15px', borderRadius: '8px' }}>
                            <h3>{mcItem.merchant.name}</h3>
                            {mcItem.items.map(item => (
                                <div key={item.product.id} className="cart-item" style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
                                    <span>{item.product.name} x{item.quantity}</span>
                                    <span>{CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{(item.product.price * item.quantity).toFixed(2)}</span>
                                </div>
                            ))}
                            <div className="cart-subtotal" style={{ marginTop: '10px', paddingTop: '10px', borderTop: '1px solid #eee' }}>
                                小计: {CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{itemSubtotal.toFixed(2)}
                            </div>
                            
                            {parseInt(merchantId) === currentMerchantId && (
                                <div className="coupon-section-cart" style={{ margin: '15px 0', padding: '12px', background: '#f9f9f9', borderRadius: '8px' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                        <span style={{ fontWeight: 'bold' }}>🎫 优惠券</span>
                                        {selectedCoupon && (
                                            <button 
                                                onClick={cancelCoupon}
                                                style={{ background: 'none', border: 'none', color: '#ff6b6b', cursor: 'pointer' }}
                                            >
                                                取消使用
                                            </button>
                                        )}
                                    </div>
                                    
                                    {selectedCoupon ? (
                                        <div style={{ background: '#fff3e0', padding: '10px', borderRadius: '6px', border: '1px solid #ffd700' }}>
                                            <div style={{ fontWeight: 'bold', color: '#ff6b6b' }}>
                                                已使用：{selectedCoupon.name}
                                            </div>
                                            <div>满{selectedCoupon.min_amount}减{selectedCoupon.reduction_amount}</div>
                                            <div style={{ color: 'green', marginTop: '5px' }}>
                                                已优惠：{CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{discount.toFixed(2)}
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            {userCoupons.length > 0 ? (
                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                                    {userCoupons.map(coupon => {
                                                        const isValid = itemSubtotal >= parseFloat(coupon.min_amount);
                                                        return (
                                                            <div 
                                                                key={coupon.id} 
                                                                style={{ 
                                                                    display: 'flex', 
                                                                    justifyContent: 'space-between', 
                                                                    alignItems: 'center',
                                                                    padding: '8px',
                                                                    background: isValid ? '#fff' : '#f0f0f0',
                                                                    borderRadius: '6px',
                                                                    border: isValid ? '1px solid #ddd' : '1px solid #eee',
                                                                    opacity: isValid ? 1 : 0.6
                                                                }}
                                                            >
                                                                <div>
                                                                    <div style={{ fontWeight: 'bold' }}>{coupon.name}</div>
                                                                    <div style={{ fontSize: '12px', color: '#666' }}>
                                                                        满{coupon.min_amount}减{coupon.reduction_amount}
                                                                    </div>
                                                                </div>
                                                                <button
                                                                    onClick={() => isValid && selectCoupon(coupon)}
                                                                    disabled={!isValid}
                                                                    style={{
                                                                        background: isValid ? '#ff6b6b' : '#ccc',
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        padding: '5px 12px',
                                                                        cursor: isValid ? 'pointer' : 'not-allowed'
                                                                    }}
                                                                >
                                                                    {isValid ? '使用' : '不满足'}
                                                                </button>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div style={{ color: '#999', textAlign: 'center', padding: '10px' }}>
                                                    暂无可用优惠券
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                            
                            <div className="cart-total" style={{ fontSize: '18px', fontWeight: 'bold', margin: '10px 0' }}>
                                合计: {CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{itemFinalAmount.toFixed(2)}
                                {itemDiscount > 0 && (
                                    <span style={{ fontSize: '14px', color: 'green', marginLeft: '10px' }}>
                                        (已优惠 {CURRENCY_SYMBOLS[merchantCurrency] || '¥'}{itemDiscount.toFixed(2)})
                                    </span>
                                )}
                            </div>
                            
                            {paymentMethods.length > 0 && (
                                <div className="payment-selection" style={{ margin: '10px 0' }}>
                                    <p>选择支付方式：</p>
                                    {paymentMethods.map(method => (
                                        <label key={method} style={{ marginRight: '15px' }}>
                                            <input
                                                type="radio"
                                                name={`payment_${merchantId}`}
                                                value={method}
                                                checked={selectedPayment === method}
                                                onChange={() => setSelectedPayment(method)}
                                            />
                                            {method}
                                        </label>
                                    ))}
                                </div>
                            )}
                            <div className="delivery-address">
                                <label>配送地址</label>
                                <input
                                    type="text"
                                    value={deliveryAddress}
                                    onChange={(e) => setDeliveryAddress(e.target.value)}
                                    placeholder="请输入详细地址"
                                />
                                <textarea
                                    placeholder="地址备注（门牌号、楼层等）"
                                    value={addressNote}
                                    onChange={(e) => setAddressNote(e.target.value)}
                                    rows="2"
                                    style={{ marginTop: '8px', width: '100%' }}
                                />
                            </div>
                            <button 
                                onClick={() => placeOrder(parseInt(merchantId), itemFinalAmount, selectedCoupon)}
                                disabled={itemFinalAmount <= 0}
                                style={{
                                    background: 'white',
                                    color: '#ff6b6b',
                                    border: '2px solid #ff6b6b',
                                    padding: '12px 20px',
                                    borderRadius: '30px',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    width: '100%',
                                    cursor: itemFinalAmount > 0 ? 'pointer' : 'not-allowed',
                                    marginTop: '16px',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    if (itemFinalAmount > 0) {
                                        e.target.style.background = '#ff6b6b';
                                        e.target.style.color = 'white';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (itemFinalAmount > 0) {
                                        e.target.style.background = 'white';
                                        e.target.style.color = '#ff6b6b';
                                    }
                                }}
                            >
                                {itemFinalAmount > 0 ? `去结算 • ${CURRENCY_SYMBOLS[merchantCurrency] || '¥'} ${itemFinalAmount.toFixed(2)}` : '去结算'}
                            </button>
                        </div>
                    );
                })}
            </div>
        );
    };

    const renderOrders = () => {
        return <OrderList orders={orders} onBack={() => setView('cities')} onReview={submitReview} />;
    };

    return (
        <div className="App">
            <div className="app-navbar" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 16px',
                background: '#fff',
                borderBottom: '1px solid #eee'
            }}>
                <div 
                    onClick={() => setView('cities')}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        cursor: 'pointer'
                    }}
                >
                    <img 
                        src="https://admin.openfood.store/uploads/1774698062238-394911561.jpg"
                        alt="OpenFood"
                        style={{ height: '32px', width: 'auto', borderRadius: '4px' }}
                    />
                    <span style={{ fontWeight: '500', fontSize: '16px', color: '#333' }}>OpenFood</span>
                </div>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                    <button 
                        onClick={() => { fetchOrders(); setView('orders'); }}
                        style={{
                            background: 'none',
                            border: 'none',
                            fontSize: '14px',
                            color: '#333',
                            cursor: 'pointer'
                        }}
                    >
                        我的订单
                    </button>
                    {Object.keys(cart).length > 0 && (
                        <button 
                            onClick={() => setView('cart')}
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '14px',
                                color: '#666',
                                cursor: 'pointer',
                                position: 'relative'
                            }}
                        >
                            🛒 购物车
                            <span style={{
                                position: 'absolute',
                                top: '-8px',
                                right: '-12px',
                                background: '#ff6b6b',
                                color: 'white',
                                borderRadius: '50%',
                                padding: '2px 6px',
                                fontSize: '10px',
                                minWidth: '18px'
                            }}>
                                {Object.values(cart).reduce((sum, mc) => sum + mc.items.reduce((s, i) => s + i.quantity, 0), 0)}
                            </span>
                        </button>
                    )}
                </div>
            </div>

            {view === 'cities' && renderCities()}
            {view === 'merchants' && renderMerchants()}
            {view === 'products' && renderProducts()}
            {view === 'productDetail' && renderProductDetail()}
            {view === 'cart' && renderCart()}
            {view === 'orders' && renderOrders()}
            {view === 'searchProducts' && renderSearchProducts()}
            {view === 'rentcar' && <RentCar />}   {/* 新增这一行 */}
        </div>
    );
}

export default App;